import {
	departmentLibraryCollectionRoute,
	departmentLibraryCollectionsRoute,
	departmentProfessionalResourceRoute,
} from 'lib/routes';

interface ILibraryRouteDocument {
	_type?: string;
	department?: string | { current?: string; slug?: { current?: string } };
	departmentSlug?: string;
	language?: string;
	slug?: { current?: string } | string;
}

export const routeForLibraryDocument = (
	document?: ILibraryRouteDocument,
): string | null => {
	if (!document?._type) {
		return null;
	}

	const departmentSlug =
		document.departmentSlug || getDepartmentSlug(document.department);

	if (!departmentSlug) {
		return null;
	}

	if (document._type === 'departmentLibraryCollectionsPage') {
		return withLocale(
			departmentLibraryCollectionsRoute(departmentSlug),
			document.language,
		);
	}

	const documentSlug =
		typeof document.slug === 'string' ? document.slug : document.slug?.current;

	if (document._type === 'libraryCollection' && documentSlug) {
		return withLocale(
			departmentLibraryCollectionRoute(departmentSlug, documentSlug),
			document.language,
		);
	}

	if (document._type === 'professionalResource' && documentSlug) {
		return withLocale(
			departmentProfessionalResourceRoute(departmentSlug, documentSlug),
			document.language,
		);
	}

	return null;
};

const getDepartmentSlug = (
	department?: string | { current?: string; slug?: { current?: string } },
) => {
	if (!department) return null;
	if (typeof department === 'string') return department;
	if (department?.current) return department.current;
	return department?.slug?.current || null;
};

const withLocale = (route: string, locale = 'en') => {
	if (locale && locale !== 'en') {
		return `/${locale}${route}`;
	}

	return route;
};
